import { AppThunk } from '../../../../store/types';
import { PlayerController } from '../../../../effects/player/manager/playerController';
import { EShortcutsListenerContainer, setShortcutsListenerContainer } from '../../../../effects/shortcutsListener';
import { EVocabularyPhraseSaveType } from '../../../../types/common';

export class PhraseListPlayControlsEvents {

	public static onPlay(
		saveType?: EVocabularyPhraseSaveType,
	): AppThunk {
		return (
			dispatch,
			getState
		) => {
			if (saveType === EVocabularyPhraseSaveType.TRANSLATE) {
				PlayerController.getInstance().playPhraseListTranslated(false);
			} else {
				PlayerController.getInstance().playPhraseList(false);
			}
			setShortcutsListenerContainer(EShortcutsListenerContainer.PHRASES);
		}
	}

	public static onStop(): AppThunk {
		return (
			dispatch,
			getState
		) => {
			PlayerController.getInstance().stopPhraseList();
		}
	}

	public static onPrev(
		saveType?: EVocabularyPhraseSaveType,
	): AppThunk {
		return (
			dispatch,
			getState
		) => {
			if (saveType === EVocabularyPhraseSaveType.TRANSLATE) {
				PlayerController.getInstance().playPrevTranslated();
			} else {
				PlayerController.getInstance().playPrevPhraseList();
			}
			setShortcutsListenerContainer(EShortcutsListenerContainer.PHRASES);
		}
	}

	public static onNext(
		saveType?: EVocabularyPhraseSaveType,
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			if (saveType === EVocabularyPhraseSaveType.TRANSLATE) {
				PlayerController.getInstance().playNextTranslated();
			} else {
				PlayerController.getInstance().playNextPhraseList();
			}
			setShortcutsListenerContainer(EShortcutsListenerContainer.PHRASES);
		}
	}

}